import apiRequest from '@app/utils/apiRequest';

export const requestFetchDicts = (key) =>
    apiRequest.get(`/extract-dict/list`, {params:{key: key}});

export const requestSaveDicts = (data) =>
    apiRequest.post(`/extract-dict/list`, data);

export const requestDownloadCV = async (filePath) => {
    if (filePath) {
        const res = await apiRequest.get(`/candidate/download-cv`, {params: {filePath: filePath}, responseType: 'blob'});
        if (res) {
            const file = new Blob(
                [res],
                {type: 'application/pdf'});
            return URL.createObjectURL(file)
        }
    }

    return ""
};

// Extract candidate info from refer check.
export const processReferCheck = (data) =>
    apiRequest.post(`candidate/process-refer-check-content`, data);
